/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { DeleteManualEntryMutationResponse, DeleteManualEntryPathParams, DeleteManualEntry400, DeleteManualEntry401, DeleteManualEntry403, DeleteManualEntry404, DeleteManualEntry409, DeleteManualEntry500 } from "../../types/financialHubController/DeleteManualEntry.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getDeleteManualEntryUrl(organizationId: DeleteManualEntryPathParams["organizationId"], transactionId: DeleteManualEntryPathParams["transactionId"]) {
  const res = { method: 'DELETE', url: `/api/organizations/${organizationId}/financial/transactions/${transactionId}` as const }
  return res
}

/**
 * @summary Delete a manual ledger entry
 * {@link /api/organizations/:organizationId/financial/transactions/:transactionId}
 */
export async function deleteManualEntry(organizationId: DeleteManualEntryPathParams["organizationId"], transactionId: DeleteManualEntryPathParams["transactionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteManualEntryMutationResponse, ResponseErrorConfig<DeleteManualEntry400 | DeleteManualEntry401 | DeleteManualEntry403 | DeleteManualEntry404 | DeleteManualEntry409 | DeleteManualEntry500>, unknown>({ method : "DELETE", url : getDeleteManualEntryUrl(organizationId, transactionId).url.toString(), ... requestConfig })
  return res.data
}